import store from '../store'

export const updateScopes = (token) => {
  const tokenDecodablePart = token.split('.')[1]
  const decoded = Buffer.from(tokenDecodablePart, 'base64').toString()
  const tokenJSON = JSON.parse(decoded)
  var user = store.get('user')
  user.permissions = [...tokenJSON.permissions]
}

export const updateMenuDrawer = async () => {
  const app = store.get('app')
  const user = store.get('user')
  const salesTeam = await user.checkPermission('read:salesTeam')
  if (salesTeam) {
    var found = false
    for (let index = 0; index < app.items.length; index++) {
      const item = app.items[index]
      if (item.title === 'Sales Team Dashboard') {
        found = true
      }
    }
    if (found === false) {
      app.items.push({
        title: 'Sales Team Dashboard',
        icon: 'mdi-chart-bar',
        to: '/SalesTeamDashboard',
      })
    }
  }
}
